<template lang="pug">
template(v-if="!isMobile")
    date-desktop(
        :field="field"
        :selected="selected"
        :showLabel="showLabel"
        @select="select"
    )

div(v-else)
    date-mobile(
        :field="field"
        :selected="selected"
        :showLabel="showLabel"
        @select="select"
    )
</template>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";
import moment, {Moment} from 'moment';
import DateMobile from "@/components/settings_element/date/DateMobile";
import DateDesktop from "@/components/settings_element/date/DateDesktop";

export default {
    name: "Date",
    components: {DateMobile, GlobalFormGroup, DateDesktop},
    props: {
        field: {},

        selected: {
            type: Object,
            default() {
                return {
                    value: {
                        d: 1,
                        m: 1,
                        y: 2021
                    }
                }
            }
        },
        showLabel: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            defaultPicker: '',
            d_tmp: 1,
            m_tmp: 1,
            y_tmp: 2020,
            date_mobile: ''
        }
    },


    mounted() {
        this.d_tmp = this.selected ? this.selected.value.day : '';
        this.m_tmp = this.selected ? this.selected.value.month : '';
        this.y_tmp = this.selected ? this.selected.value.year : '';
        this.defaultPicker = moment(`${this.d_tmp}/${this.m_tmp}/${this.y_tmp}`, 'D/M/YYYY');
    },

    computed: {
        isMobile() {
            return nse_app.isMobile;
        }
    },
    methods: {
        select(value) {
            this.$emit('select', value);
        },
    }
}
</script>

<style lang="scss">
.date-select {
    select {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid black;
        padding: 5px 2px;

        + select {
            margin-left: 10px;
        }
    }
}

.wrap-date-native {
    position: relative;

    button {
        width: 100%;
        text-align: left;
        border: none;
        border-bottom: 1px solid black;
        padding-left: 0;
        padding-right: 0;
    }

    input {
        position: absolute;
        border: none;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        z-index: 88;
        display: block;
    }
}
</style>
